const tryInitSerieCards = () => {
	const cardsReady = document.querySelectorAll('.js-series-card').length > 0;
	const dataReady = Array.from(document.querySelectorAll('.js-series-card')).every(el => {
		return !!window[el.dataset.id];
	});

	if (cardsReady && dataReady) {
		serieCards();
	} else {
		// Retry every 100ms until DOM and data are ready
		setTimeout(tryInitSerieCards, 100);
	}
};

$(function () {
	engagementSliders();
	//serieCards();
    //setTimeout(serieCards, 200);
    //tryInitSerieCards();
});

function engagementSliders() {
	const sliderEls = [...document.querySelectorAll('.js-engagement-slideshow')];
	
	if(!sliderEls || sliderEls.length === 0) {
		return;
	}

	sliderEls.forEach(element => {
		const currentIndexEl = element.parentElement.querySelector('.js-current-index');

		$(element).slick({
			infinite: true,
			arrows: false,
			dots: true,
			dotsClass: 'slick-indicators',
			autoplay: true,
			speed: 500,
			autoplaySpeed: 15000,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			pauseOnDotsHover: false,
			pauseOnFocus: false,
            lazyLoad: 'ondemand'
		});

		$(element).on('afterChange', function(_, _, currentSlide) {
			currentIndexEl.innerHTML = `${currentSlide + 1}`;
		});
	});
}

const serieCards = () => {
  const linkAppendix = '/products/';
  const cards = document.querySelectorAll('.js-series-card');
  if (!cards.length) return;

  cards.forEach(card => {
    const dataKey = card.dataset.id;
    const products = window[dataKey];
    if (!products) {
      console.warn('Missing product array for', dataKey);
      return;
    }

    //const radios    = [...card.querySelectorAll('input[name="carat"]')];
    const radios = [...card.querySelectorAll('input[type=radio]')];
    const linkEl    = card.querySelector('.js-link');
    const titleEl   = card.querySelector('.js-title');
    const priceEl   = card.querySelector('.js-from-price');
    const wrapper   = card.querySelector('.js-smartbutton-wrapper');
    const smartBtns = [...card.querySelectorAll('.js-smartbutton')];

    // 1. your “update UI” helper
    const updateUI = product => {
      titleEl.textContent = product.title;
      priceEl.textContent = `${(product.price_min / 100).toLocaleString('da-DK')} kr.`;
      linkEl.href = linkAppendix + product.handle;

      if (wrapper.hasAttribute('hidden')) wrapper.removeAttribute('hidden');

      smartBtns.forEach(btn => {
        btn.hidden = !(
          btn.dataset.product === String(product.id) &&
          btn.dataset.variant === String(product.variants[0].id)
        );
      });
    };

    // 2. wire up change-listeners
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        const pid = Number(radio.value);
        const prod = products.find(p => p.id === pid);
        if (prod) updateUI(prod);
      });
    });

    // 3. pick your default (checked in Liquid or fallback to first)
    let defaultRadio = card.querySelector('input[name="carat"]:checked');
    if (!defaultRadio && radios.length) {
      defaultRadio = radios[0];
      defaultRadio.checked = true;
    }

    // 4. call updateUI() once immediately
    if (defaultRadio) {
      const pid = Number(defaultRadio.value);
      const prod = products.find(p => p.id === pid);
      if (prod) updateUI(prod);
    }
  });
};

// ensure you run AFTER your inline <script> tags have created window.products…
$(window).on('load', serieCards);

